<template>
    <div class="agent-and-loan-officer-home-loading">
        <div class="content pb-5">
            <div class="overflow-hidden">
                <div class="cover-wrapper">
                    <b-skeleton-img
                        no-aspect
                    />
                </div>
            </div>
            <div class="cards-row d-flex align-items-center justify-content-center flex-column flex-sm-row">
                <b-card
                    v-for="index in agentCardNo"
                    :key="index"
                    class="agent-card"
                >
                    <div class="d-flex align-items-center justify-content-center flex-column">
                        <div class="avatar-wrapper">
                            <b-skeleton
                                type="avatar"
                                class="avatar-img"
                            />
                        </div>
                        <b-skeleton
                            width="55%"
                            class="details"
                        />
                        <b-skeleton
                            width="45%"
                            class="details"
                        />
                        <b-skeleton
                            width="45%"
                            class="details"
                        />
                        <b-skeleton
                            width="60%"
                            class="details"
                        />
                        <b-skeleton
                            width="50%"
                            class="details"
                        />
                        <b-skeleton
                            width="55%"
                            class="details"
                        />
                        <b-skeleton
                            width="60%"
                            class="details"
                        />
                    </div>
                </b-card>
            </div>

            <div class="info text-center mx-auto">
                <b-skeleton
                    width="80%"
                    class="mx-auto"
                />
                <b-skeleton
                    width="75%"
                    class="mx-auto mt-2"
                />
            </div>
        </div>


        <div class="footer-loading">
            <b-skeleton
                width="80%"
                class="mx-auto"
            />
            <b-skeleton
                width="75%"
                class="mx-auto mt-2"
            />
        </div>
    </div>
</template>

<script>
    import './AgentAndLoanOfficerHomeLoading.scss';
    import './AgentAndLoanOfficerHomeLoading.mobile.scss';

    export default {
        name: "AgentAndLoanOfficerHomeLoading",
        data() {
            return {
                agentCardNo: 2
            };
        }
    };
</script>
